import React, {useState} from 'react';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { IconContext } from "react-icons";

function Pagination({  totalCards, currentPage, setCurrentPage, lastPage, cardsPerPage }) {  
    const [newerPost, setNewerPost] = useState("");
    const [olderPost, setOlderPost] = useState("Next");
    const [isFirstActive, setFirstActive] = useState(false);
    const activeNext = () => {
        let paginateLinks = Array.from(document.querySelectorAll(".pagination li a"));
        let activePaginateLink = document.querySelector(".pagination li a.active");
        if (!activePaginateLink){
            activePaginateLink = document.querySelectorAll(".pagination li a")[0];
        }
        let activeIndex = paginateLinks.indexOf(activePaginateLink);
        paginateLinks[activeIndex].classList.remove('active');
        paginateLinks[activeIndex + 1].classList.add('active');
    }
    const activePrev = () => {
        let paginateLinks = Array.from(document.querySelectorAll(".pagination li a"));
        let activePaginateLink = document.querySelector(".pagination li a.active");
        let activeIndex = paginateLinks.indexOf(activePaginateLink);
        paginateLinks[activeIndex].classList.remove('active');
        paginateLinks[activeIndex - 1].classList.add('active');
    }
    const goToLeft=()=>{
        if(currentPage === 1) {
            setCurrentPage (currentPage);
            setOlderPost("Next");
            setNewerPost("");
        }else if(currentPage === 2) {
            setCurrentPage (1);
            setOlderPost("Next");
            setNewerPost("");            
            setFirstActive(true);
            setTimeout(activePrev,0);
        }else{
            setCurrentPage(currentPage - 1);
            setOlderPost("Next");
            setNewerPost("Back");
            setFirstActive(true);
            setTimeout(activePrev,0);
        }
    };

    const goToRight=()=>{
        if (currentPage === lastPage) {
        setCurrentPage(currentPage);
        setOlderPost("");
        setNewerPost("Back"); 
        }else if (currentPage === lastPage - 1) {
        setCurrentPage(lastPage);
        setOlderPost("");
        setNewerPost("Back");
        setFirstActive(true);
        setTimeout(activeNext);
    }else {
        setCurrentPage(currentPage + 1);
        setOlderPost("Next");
        setNewerPost("Back");
        setFirstActive(true);
        setTimeout(activeNext);
        }
    }

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        if (pageNumber === 1) {
        setOlderPost("Next");
        setNewerPost("");
        } else if (pageNumber === lastPage) {
        setOlderPost("");
        setNewerPost("Back"); 
        } else {
        setOlderPost("Next");
        setNewerPost("Back");
        }
    };

  const pageNumbers = [];
  for (let i = 1; i<= Math.ceil(totalCards / cardsPerPage); i++) {
        pageNumbers.push(i);
    }
    const wholePagination = document.querySelectorAll(".pagination");
    wholePagination.forEach((pagination)=>{
        if(!isFirstActive){
            pagination.classList.add("activeFirstPaginateLink");
        }else{
            pagination.classList.remove("activeFirstPaginateLink");
        }
    })
    const activePaginate = () => {
        let paginateLinks = Array.from(document.querySelectorAll(".pagination li a"));
        paginateLinks.forEach((paginateLink, index)=>{
            paginateLink.addEventListener('click',()=>{
                setFirstActive(true);
                paginateLinks.forEach((paginateLink)=>{
                    paginateLink.classList.remove("active");
                })
                paginateLinks[index].classList.add("active");
            });
        })
    }
    setTimeout(activePaginate, 0);
    // const [numbersPerPage] = useState(2);
    // let [indexOfLastNumber] = useState(numbersPerPage);
    // if (currentPage === indexOfLastNumber + 1){
    //     indexOfLastNumber = currentPage + numbersPerPage - 1;
    // }
    // const indexOfFirstNumber = indexOfLastNumber - numbersPerPage;
    // console.log(indexOfFirstNumber, indexOfLastNumber, currentPage);
    // const currentNumbers = pageNumbers.slice(indexOfFirstNumber, indexOfLastNumber); 
  return (
    <IconContext.Provider value={{size: "1rem", color: "white"}}>
        <div onClick={()=>{goToLeft()}} className="left"><FaAngleLeft/><p className="ml2"><a href="#NFTMarketPlace" className='white'>{newerPost}</a></p></div>  
        <nav>
            <ul className="pagination">
                {pageNumbers.map(number => (
                    <li key = {number}>
                        <a onClick={() => {paginate(number)}} href='#NFTMarketPlace' value={number} >
                            {number}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
        <div onClick={()=>{goToRight()}} className="right"><p className="mr2"><a href="#NFTMarketPlace" className='white'>{olderPost}</a></p><FaAngleRight/></div>
    </IconContext.Provider>
  )
}

export default Pagination;